import React from "react"
import {
    Divider,
    makeStyles,
} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

interface Props {
    titulo: string;
    colorDivisor?: string;
    colorTitulo?: string;
}

const useEstilos = makeStyles((theme) =>({
    divExterior: {
        marginBottom: '12px',
    },
    titulo: {
        marginBottom: '8px',
        fontWeight: 'bold',
        // @ts-ignore
        color: props => props?.colorTitulo ? props?.colorTitulo : theme.palette.primary.main
    },
    divider: {
        // @ts-ignore
        background: props => props?.colorDivisor?  props.colorDivisor: theme.palette.primary.main,
        height: '2px'
    },

}))
export const CabeceraSeccion = (props: Props) => {
    const clases = useEstilos(props);

    return (
        <React.Fragment>
            <div className={clases.divExterior}>
                <Typography variant="body2" component="div" classes={{ root: clases.titulo }}>{props.titulo}</Typography>
            </div>
            <Divider classes={{root:clases.divider}}></Divider>
        </React.Fragment>        
    )
}